<div class="pending-context-form">

  <div class="row">
    <mat-form-field>
      <mat-label>Select Link Type</mat-label>
      <mat-select [(ngModel)]="config.type" (selectionChange)="linkTypeSelected()"
        [disabled]="static">
        @for (link_type of link_types | keyvalue; track link_type.key) {
          <mat-option
            [value]="link_type.key">{{link_type.value}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <select-search-component
      [api_model]="'component_type'"
      [value]="config.type==='event_to_component' ? config.context.component_type : config.context.component_type_from"
      (selectionChange)="componentTypeSelected($event, config.type==='event_to_component' ? 'component_type' : 'component_type_from')"
      [disabled]="static"
      [classes]="'fill'"
      [label]="'Select Component Type'"
      class="select-search">
    </select-search-component>
  </div>

  <!--Customisation and Validation component-->
  @if (config.type==='event_to_component' && config.validation.component_type?.hasOwnProperty(config.context.component_type.id)) {
    <custom-form-field
      [config]="config.customisation.component_type[config.context.component_type.id]"
      (configChanged)="config.customisation.component_type[config.context.component_type.id] = $event"
      [title]="'Add customisation for this ' + ct_dict[config.context.component_type.id]?.attributes.name || ''">
    </custom-form-field>
    <pending-context-validation
      [config]="config.validation.component_type[config.context.component_type.id]"
      (configChanged)="config.validation.component_type[config.context.component_type.id] = $event"
      [title]="'Add validation for this ' + ct_dict[config.context.component_type.id]?.attributes.name || ''">
    </pending-context-validation>
  }
  @if (config.type==='component_to_component' && config.validation.component_type_from?.hasOwnProperty(config.context.component_type_from.id)) {
    <custom-form-field
      [config]="config.customisation.component_type_from[config.context.component_type_from.id]"
      (configChanged)="config.customisation.component_type_from[config.context.component_type_from.id] = $event"
      [title]="'Add customisation for  this ' + ct_dict[config.context.component_type_from.id]?.attributes.name">
    </custom-form-field>
    <pending-context-validation
      [config]="config.validation.component_type_from[config.context.component_type_from.id]"
      (configChanged)="config.validation.component_type_from[config.context.component_type_from.id] = $event"
      [title]="'Add validation for this ' + ct_dict[config.context.component_type_from.id]?.attributes.name">
    </pending-context-validation>
  }

  <!--If component_to_component --------------------------------------------------------------------------------------->
  @if (config.type==='component_to_component') {
    <div class="row">
      <select-search-component
        [api_model]="'component_type'"
        [value]="config.context.component_type_to"
        (selectionChange)="componentTypeSelected($event, 'component_type_to')"
        [classes]="'fill'"
        [disabled]="static"
        [label]="'Select Component Type'"
        class="select-search"
        [matTooltip]="ct_dict[config?.context?.component_type_to?.id]?.attributes?.name">
      </select-search-component>
    </div>
  }
  <!--Validation component-->
  @if (config.type==='component_to_component' && config.validation.component_type_to?.hasOwnProperty(config.context.component_type_to.id)) {
    <custom-form-field
      [config]="config.customisation.component_type_to[config.context.component_type_to.id]"
      (configChanged)="config.customisation.component_type_to[config.context.component_type_to.id] = $event"
      [include_options]="['label']"
      [title]="'Add customisation for this ' + ct_dict[config.context.component_type_to.id]?.attributes.name || ''">
    </custom-form-field>
    <pending-context-validation
      [config]="config.validation.component_type_to[config.context.component_type_to.id]"
      (configChanged)="config.validation.component_type_to[config.context.component_type_to.id] = $event"
      [title]="'Add validation for this ' + ct_dict[config.context.component_type_to.id]?.attributes.name || ''">
    </pending-context-validation>
  }

  <!--If event_to_component ------------------------------------------------------------------------------------------->
  @if (config.type==='event_to_component') {
    <div class="row center">
      @if (config.context.component_type.id) {
        @if (!event_types) {
          <div>Loading Event Types...</div>
        }
        @if (event_types) {
          <select-search
            (selectChange)="eventTypeSelected($event)"
            [data]="event_types"
            [value]="config.context.event_type"
            [compareWith]="eventsService.compareById"
            label="Select Event Type" class="select-search">
          </select-search>
          <select-many-search-component
            [api_model]="'constant_property_light'"
            (selectionChange)="propertiesSelected($event)"
            [value]="config.context.event_type.constant_properties"
            [custom_filters]="getEventTypeConstantPropertyFilter()"
            [classes]="'fill'"
            [label]="'Select Constant Properties'"
            class="select-search">
          </select-many-search-component>
        }
      }
    </div>
    @if (config.context?.event_type?.id && config.context.event_type.constant_properties
      && config.context.event_type.constant_properties.length > 0) {
      <div class="row" style="width:100%;">
        <mat-form-field>
          <mat-label>Select Constant Property with unique values</mat-label>
          <mat-select [(ngModel)]="config.context.event_type.unique_constant_property">
            @for (constant_property of config.context.event_type.constant_properties; track constant_property) {
              <mat-option
                [value]="constant_property.id">{{cp_dict[constant_property.id]?.attributes | nameOrDescription}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
    <!--Customisation and Validation options for selected constant properties----------------------------------------------------------->
    @if (config.context.event_type.constant_properties) {
      @for (cp of config.context.event_type.constant_properties; track cp) {
        <custom-form-field [config]="config.customisation.constant_properties[cp.id]"
          (configChanged)="config.customisation.constant_properties[cp.id] = $event"
          [title]="'Add customisation for ' + cp_dict[cp.id]?.attributes?.name || ''">
        </custom-form-field>
        <pending-context-validation [config]="config.validation.constant_properties[cp.id]"
          (configChanged)="config.validation.constant_properties[cp.id] = $event"
          [title]="'Add validation for ' + cp_dict[cp.id]?.attributes?.name">
        </pending-context-validation>
      }
    }
  }

</div>
